import React, { useEffect, useState, useMemo } from "react";
import { Icon, notification, Popconfirm, Menu, Dropdown, Modal, Tooltip } from "antd";
import { currencyFormat } from "../../../../../utils/common";
import styles from "../../JobStyle.module.css";
import { useDispatch } from "react-redux";
import { getJobTasks, deleteSiteTask, updateTaskInvoiceState, cancelReAllocateTask, cancelTask } from "../../../../../actions/v2/JobActions";
import { Strings } from "../../../../../dataProvider/localize"
import AddNewTask from "./AddNewTask";
import moment from "moment";
import CloseIcon from '@mui/icons-material/Close';
import v2Styles from "../../../v2Styles.module.css";
import CancelTaskFrequenciesModal from "./CancelTaskFrequenciesModal";
import { CircularProgress, IconButton } from "@mui/material";


export default function TaskHeader(props) {

  const dispatch = useDispatch();
  const [isJobTask, setIsJobTask] = useState(false);
  const [taskState, setTaskState] = useState("");
  const [visibleDeleteTask, setVisibleDeleteTask] = useState(false);
  const [confirmInvoicing, setConfirmInvoicing] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [invoiceStatus, setInvoiceStatus] = useState(0);
  const [allCancelled, setAllCancelled] = useState(false);
  const [confirmCancel, setConfirmCancel] = useState(false);
  const [cancelFrequenies, setCancelFrequencies] = useState(false);

  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (props.taskDetails && props.taskDetails.task_type && props.taskDetails.task_type === "JOB_TASK") {
      setIsJobTask(true);
    }
    if (props.taskDetails && props.taskDetails.task_state) {
      setTaskState(props.taskDetails.task_state);
      let status = 0;
      if (props.taskDetails.invoice_number && props.taskDetails.invoice_number !== null && props.taskDetails.xero_invoice_state && props.taskDetails.xero_invoice_state !== null) {
        status = 3;
      } else if (props.taskDetails.job_board_task_state && props.taskDetails.job_board_task_state.toLowerCase() === "values approved for invoice") {
        status = 2;
      } else if (props.taskDetails.job_board_task_state && props.taskDetails.job_board_task_state.toLowerCase() === "confirm values approved for invoice") {
        status = 1;
      }
      setInvoiceStatus(status);
    }
    if (props.taskDetails && props.taskDetails.contractor_details && props.taskDetails.contractor_details.every(cont => cont.contractor_task_status && cont.contractor_task_status.toString().toLowerCase() === "cancelled")) {
      setAllCancelled(true);
    } else {
      setAllCancelled(false);
    }
  }, [props.taskDetails])


  const isInvoiced = useMemo(() => {
    let res = false;
    if (props.taskDetails && props.taskDetails.ar_state && props.taskDetails.ar_state.toLowerCase() === "invoiced") {
      res = true;
    }
    return res;
  }, [props.taskDetails])

  const isPartiallyInvoiced = useMemo(() => {
    let res = false;
    if (props.taskDetails && props.taskDetails.ar_state && props.taskDetails.ar_state.toLowerCase() === "partially invoiced") {
      res = true;
    }
    return res;
  }, [props.taskDetails])

  const handleOptionsClick = ({ key }) => {
    // if (key === "photos") {
    //   if (props.taskDetails && props.taskDetails.task_files && props.job) {
    //     let url = process.env.REACT_APP_CLIENT_APP_URL ? process.env.REACT_APP_CLIENT_APP_URL : "";
    //     url = url + "/task_image_preview" + generateImgUrl(props.taskDetails.task_files, props.taskDetails, props.job)
    //     window.open(url, "_blank");
    //   }
    // } else if (key === "cancel" || key === "reAllocate") {
    //   let formData = {
    //     job_id: props.job.job_id,
    //     task_label: props.taskDetails.task_number,
    //     task_state: key === "cancel" ? "Cancelled" : "Allocated",
    //     ...(props.taskDetails.quote_task_id ? { quote_task_id: props.taskDetails.quote_task_id } : {}),
    //     ...(props.taskDetails.task_invoice_id ? { task_invoice_id: props.taskDetails.task_invoice_id } : {})
    //   }

    //   dispatch(cancelReAllocateTask(formData)).then((message) => {
    //     dispatch(getJobTasks(props.job.job_id))
    //     notification.success({
    //       message: Strings.success_title,
    //       description: message ? message : Strings.generic_error,
    //       className: 'ant-success'
    //     });
    //   }).catch(err => {
    //     notification.error({
    //       message: Strings.error_title,
    //       description: err ? err : Strings.generic_error,
    //       className: 'ant-error'
    //     })
    //   })
    // }
    if (key === "cancel-task") {
      setConfirmCancel(true);
    }
    if (key === "cancel-task-frequency") {
      setCancelFrequencies(true)
    }
  }

  const cancelCurrentTask = () => {
    if (props.taskDetails && props.taskDetails.task_id) {
      setSubmitting(true);
      const formData = {
        job_id: props.job.job_id,
        job_cost: props.job.job_total_amount,
        task_id: props.taskDetails.task_id,
        task_cost: props.taskDetails.task_cost,
        booking_type: props.taskDetails.booking_type
      }
      dispatch(cancelTask(formData)).then(message => {
        setConfirmCancel(false);
        props.refreshJobBoard();
        setSubmitting(false);
        notification.success({
          message: Strings.success_title,
          description: message ? message : Strings.generic_error,
          className: 'ant-success'
        });
      }).catch(err => {
        setSubmitting(false);
        notification.error({
          message: Strings.error_title,
          description: err ? err : Strings.generic_error,
          className: 'ant-error'
        })
      })
    }
  }

  // const generateImgUrl = (files, task, quoteDetails) => {
  //   return `?imgs=${encodeURIComponent(JSON.stringify(files.map(file => ({ image: `${file.file_base_path}${file.file_name}`, note: file.notes ? file.notes : "" }))))}${quoteDetails.job_name ? "&job=" + quoteDetails.job_name : ""}&task=${task.task_name}&v=2`;
  // }

  const menu = (
    <Menu onClick={handleOptionsClick} className="cs-menu-dropdown">
      {/* <Menu.Item key="photos" disabled={!(props.taskDetails && props.taskDetails.task_files && props.taskDetails.task_files.length > 0)}>
        <div className="px-2">Photos</div>
      </Menu.Item>
      <Menu.Divider /> */}
      {/* {props.taskDetails && props.taskDetails.task_state && props.taskDetails.task_state.toString().toLowerCase() === "cancelled" ? (
        <Menu.Item key="reAllocate" disabled={invoiceStatus === 3 || allCancelled === false}>
          <div className="px-2">Re-Allocate Task</div>
        </Menu.Item>) : (
        <Menu.Item key="cancel" disabled={invoiceStatus === 3 || allCancelled === false}>
          <div className="px-2">Cancel Task</div>
        </Menu.Item>)
      } */}
      <Menu.Item key="cancel-task" disabled={props.taskDetails && props.taskDetails.task_state.toString().toLowerCase() === "cancelled"}>
        <div className="px-2">Cancel Task</div>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="cancel-task-frequency" disabled={props.taskDetails && props.taskDetails.task_state.toString().toLowerCase() === "cancelled"}>
        <div className="px-2">Cancel Task Frequency</div>
      </Menu.Item>
    </Menu>
  )

  // const taskStates = ["Booked", "Allocated", "Outsourced", "Started", "Completed", "Signed Off", "Cancelled"];

  // const sendTaskForInvoicing = () => {
  //   if (props.taskDetails.task_invoice_id) {
  //     let formData = {
  //       task_invoice_id: props.taskDetails.task_invoice_id,
  //       job_board_task_state: "Confirm Values Approved for Invoice",
  //       job_id: props.job.job_id
  //     }
  //     dispatch(updateTaskInvoiceState(formData)).then((message) => {
  //       setConfirmInvoicing(false);
  //       dispatch(getJobTasks(props.job.job_id))
  //       notification.success({
  //         message: Strings.success_title,
  //         description: message ? message : Strings.generic_error,
  //         className: 'ant-success'
  //       });
  //     }).catch(err => {
  //       cancelTaskStateChange();
  //       notification.error({
  //         message: Strings.error_title,
  //         description: err ? err : Strings.generic_error,
  //         className: 'ant-error'
  //       })
  //     })
  //   } else {
  //     setConfirmInvoicing(false)
  //     notification.error({
  //       message: Strings.error_title,
  //       description: Strings.generic_error,
  //       className: 'ant-error'
  //     })
  //   }
  // }

  const deleteTask = () => {
    dispatch(deleteSiteTask(props.taskDetails.id, props.job.job_id, props.taskDetails.task_number)).then((message) => {
      dispatch(getJobTasks(props.job.job_id))
      notification.success({
        message: Strings.success_title,
        description: message ? message : Strings.generic_error,
        className: 'ant-success'
      });
    }).catch(err => {
      cancelTaskStateChange();
      notification.error({
        message: Strings.error_title,
        description: err ? err : Strings.generic_error,
        className: 'ant-error'
      })
    })
  }

  const cancelTaskStateChange = () => {
    setTaskState(props.taskDetails.task_state);
  }

  const getTaskInitialValues = () => {
    let values = {
      task_name: props.taskDetails.task_name,
      area_name: props.taskDetails.area_name,
      note: props.taskDetails.task_note,
      task_total: props.taskDetails.task_cost.toString()
    };
    return values;
  }

  return (
    <>
      {isEditing ? (
        <AddNewTask
          isEditing={true}
          form={`EditTaskForm-${props.taskDetails.id}`}
          task={props.taskDetails}
          initialValues={getTaskInitialValues()}
          onClose={() => setIsEditing(false)}
        />
      ) : (
        <div className={`${styles.TaskHeader}`}>
          <div className="container-fluid">
            <div className="row align-items-top">
              <div className="col-4">
                <div className={styles.PrimaryText}>
                  <div className="font-weight-bold">
                    {props.taskDetails && props.taskDetails.task_number && props.taskDetails.task_number}
                  </div>
                  <div>
                    {props.taskDetails && props.taskDetails.task_name && props.taskDetails.task_name}
                  </div>
                  <div>
                    {props.taskDetails && props.taskDetails.area_name && props.taskDetails.area_name}
                  </div>
                  {props.taskDetails && props.taskDetails.task_note &&
                    <div className="freq-task-conditions freq-task-conditions-normal" dangerouslySetInnerHTML={{ __html: props.taskDetails.task_note }}></div>
                  }
                </div>
              </div>
              <div className="col-8 px-0">
                <div className="container-fluid px-2">
                  <div className="row align-items-center">
                    <div className={`col-2 px-0 ${props.taskDetails.task_state && props.taskDetails.task_state === "Cancelled" && (props.taskDetails.task_cost && parseFloat(props.taskDetails.task_cost)) ? styles.redLineThrough : ""}`}>
                      {props.taskDetails && props.taskDetails.task_cost && props.canSeeValues ? currencyFormat(props.taskDetails.task_cost) : ''}
                    </div>
                    <div className="col-3 pl-0">
                      <div className={`${styles.jobStatusBox} job-board-status-${taskState ? taskState.toLowerCase().replaceAll(" ", "") : ""}`}>
                        <div style={{ lineHeight: '1.5' }}>{taskState}</div>
                      </div>
                    </div>
                    <div className="col-3 pl-0">
                      {isInvoiced ? (
                        <Tooltip title="Invoiced">
                          <span>
                            <IconButton className={`${v2Styles.IconBtn} ${v2Styles.PrimaryColor}`} style={{ height: "auto" }}>
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" style={{ width: "26px", height: "26px" }}>
                                <path fill="currentColor" d="M128 128C128 92.7 156.7 64 192 64L341.5 64C358.5 64 374.8 70.7 386.8 82.7L493.3 189.3C505.3 201.3 512 217.6 512 234.6L512 512C512 547.3 483.3 576 448 576L192 576C156.7 576 128 547.3 128 512L128 128zM336 122.5L336 216C336 229.3 346.7 240 360 240L453.5 240L336 122.5zM192 152C192 165.3 202.7 176 216 176L264 176C277.3 176 288 165.3 288 152C288 138.7 277.3 128 264 128L216 128C202.7 128 192 138.7 192 152zM192 248C192 261.3 202.7 272 216 272L264 272C277.3 272 288 261.3 288 248C288 234.7 277.3 224 264 224L216 224C202.7 224 192 234.7 192 248zM304 324L304 328C275.2 328.3 252 351.7 252 380.5C252 406.2 270.5 428.1 295.9 432.3L337.6 439.3C343.6 440.3 348 445.5 348 451.6C348 458.5 342.4 464.1 335.5 464.1L280 464C269 464 260 473 260 484C260 495 269 504 280 504L304 504L304 508C304 519 313 528 324 528C335 528 344 519 344 508L344 503.3C369 499.2 388 477.6 388 451.5C388 425.8 369.5 403.9 344.1 399.7L302.4 392.7C296.4 391.7 292 386.5 292 380.4C292 373.5 297.6 367.9 304.5 367.9L352 367.9C363 367.9 372 358.9 372 347.9C372 336.9 363 327.9 352 327.9L344 327.9L344 323.9C344 312.9 335 303.9 324 303.9C313 303.9 304 312.9 304 323.9z" />
                              </svg>
                            </IconButton>
                          </span>
                        </Tooltip>
                      ) : null}
                      {isPartiallyInvoiced ? (
                        <Tooltip title="Partially Invoiced">
                          <span>
                            <IconButton className={`${v2Styles.IconBtn} ${v2Styles.PrimaryColor}`} style={{ height: "auto" }}>
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" style={{ width: "26px", height: "26px" }}>
                                <path fill="currentColor" d="M192 64C156.7 64 128 92.7 128 128L128 384L512 384L512 234.5C512 217.5 505.3 201.2 493.3 189.2L386.7 82.7C374.7 70.7 358.5 64 341.5 64L192 64zM453.5 240L360 240C346.7 240 336 229.3 336 216L336 122.5L453.5 240zM128 416L128 480L192 480L192 416L128 416zM192 576L192 512L128 512C128 547.3 156.7 576 192 576zM224 576L304 576L304 512L224 512L224 576zM336 576L416 576L416 512L336 512L336 576zM448 576C483.3 576 512 547.3 512 512L448 512L448 576zM512 416L448 416L448 480L512 480L512 416z" />
                              </svg>
                            </IconButton>
                          </span>
                        </Tooltip>
                      ) : null}
                      {invoiceStatus === 2 || invoiceStatus === 3 ?
                        <div className={`text-center ${props.taskDetails && props.taskDetails.task_state === "Started" && invoiceStatus === 2 ? styles.DisabledText : ''}`}>
                          <div>Values Approved for Invoice</div>
                          <div>{props.taskDetails.invoice_approver_name && props.taskDetails.invoice_approver_name}{props.taskDetails.invoice_approved_at ? ` - ${moment(props.taskDetails.invoice_approved_at).format("DD/MM/YYYY")}` : ''}</div>
                        </div>
                        // // Commented for New Approve Invoice Button
                        // : invoiceStatus === 1 && !props.isDisabledJob ?
                        //   <Popconfirm
                        //     title={<div onClick={e => e.stopPropagation()}>
                        //       <div className="font-weight-bold">Are you sure you want to confirm values of this task for Invoicing?</div>
                        //       <div>This change is not reversible.</div>
                        //     </div>}
                        //     visible={confirmInvoicing}
                        //     onCancel={(e) => { e.stopPropagation(); setConfirmInvoicing(false) }}
                        //     onConfirm={(e) => { e.stopPropagation(); sendTaskForInvoicing() }}>
                        //     <button onClick={e => { e.stopPropagation(); setConfirmInvoicing(true) }} className={styles.textButton}>Confirm Values Approved for Invoice</button>
                        //   </Popconfirm>
                        : <div className="text-center font-weight-bold"></div>}

                    </div>
                    <div className="col-auto ml-auto px-0 align-self-center text-right" onClick={(e) => e.stopPropagation()}>
                      <div className="d-flex align-items-center justify-content-end">
                        {!props.isDisabledJob ? (
                          <div className="text-right ml-auto px-0">
                            <button className={styles.PrimaryButton} type="button" onClick={() => props.setSelectedTask(props.taskDetails)}>View Frequency</button>
                          </div>
                        ) : null}
                        {isJobTask && invoiceStatus !== 3 && (props.taskDetails.task_state && props.taskDetails.task_state.toLowerCase() !== "cancelled") && (
                          <>
                            <Icon type="edit" onClick={() => setIsEditing(true)} className="mx-1" style={{ color: "green", cursor: "pointer" }} />
                            <Popconfirm
                              title={<div>
                                <div className="font-weight-bold">Are you sure you want  to delete this task?</div>
                                <div>Deleting a Task is not reversible.</div>
                              </div>}
                              visible={visibleDeleteTask}
                              onCancel={() => { setVisibleDeleteTask(false) }}
                              onConfirm={() => deleteTask()}
                            >
                              <Icon type="delete" className="mx-1" style={{ color: "red", cursor: "pointer" }} onClick={() => setVisibleDeleteTask(true)} />
                            </Popconfirm>
                          </>
                        )}
                        <Dropdown overlay={menu} trigger={['click']}>
                          <span style={{ cursor: "pointer" }} onClick={e => { e.preventDefault() }}>
                            <Icon type="more" style={{ fontSize: "16px", padding: "0px 5px" }} />
                          </span>
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">

              </div>
            </div>
          </div>
          <Modal
            className="cs-modal-v2"
            centered
            footer={null}
            visible={confirmCancel}
            onCancel={() => setConfirmCancel(false)}
            maskClosable={false}
            bodyStyle={{ paddingRight: "0px", paddingLeft: "0px" }}
            destroyOnClose={true}
            closeIcon={<div className={styles.ModalCloseIcon}><CloseIcon /></div>}
          >
            <div className="v2-modal-container">

              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    <div className={v2Styles.ModalHeading}>Are you sure you want to cancel task <b>{props.taskDetails.task_number}</b>?</div>
                    <div className=""><hr /></div>
                    <div className="">The task along with all the assoiciated Task frequencies will be cancelled.</div>
                    <div style={{ color: "red" }}>This action is not reversible.</div>

                  </div>
                </div>
                <div className="row">
                  <div className="col-12 text-right">
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "end", columnGap: "10px" }}>
                      {submitting ? <CircularProgress size={20} /> : ""}
                      <button type="button" className={`${v2Styles.OutlinedButton}`} onClick={() => setConfirmCancel(false)} style={{ padding: "0px 5px" }}>
                        Cancel
                      </button>
                      <button
                        type="button"
                        disabled={submitting}
                        onClick={() => cancelCurrentTask()}
                        className={v2Styles.PrimaryButton}>
                        Confirm
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
          <Modal
            className="cs-modal-v2"
            centered
            footer={null}
            visible={cancelFrequenies}
            onCancel={() => setCancelFrequencies(false)}
            maskClosable={false}
            bodyStyle={{ paddingRight: "0px", paddingLeft: "0px" }}
            destroyOnClose={true}
            width="700px"
            closeIcon={<div className={styles.ModalCloseIcon}><CloseIcon /></div>}
          >
            <CancelTaskFrequenciesModal job_total_amount={props.job.job_total_amount} refreshJobBoard={props.refreshJobBoard} job_id={props.job.job_id} task={props.taskDetails} onClose={() => setCancelFrequencies(false)} />
          </Modal>
        </div>
      )}
    </>
  )
}